module.exports = __webpack_public_path__ + "img/20241119_1.1d49d7e7.jpg";